import validateString from "./validateString";

const validatePassword = (password: string) => {
  return validateString(password, { isReq: true, min: 8 });
};

export default validatePassword;
